import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import mixin from '@/mixin';
import 'swiper/css/swiper.css';
import { getCookie } from '@/utils';
import NaverAnalytics from './plugins/naver-analytics';
import axios from 'axios';

Vue.mixin(mixin);
Vue.config.productionTip = false;
Vue.use(NaverAnalytics);
Vue.prototype.$axios = axios;

const lang = getCookie('gak-lang');
store.commit('setLang', lang);

const videoBase = document.querySelector('meta[property=video_base]').getAttribute('content');
store.commit('setVideoBase', videoBase);

const vueInit = () => {
  new Vue({
    render: h => h(App),
    router: router(),
    store
  }).$mount('#app');
};

vueInit();
